import { useContext, useState, useRef, useEffect } from 'react';
import styles from '../style.module.css';
import SlButton from '../../SlButton';
import { filterDataContext } from '../FilterDataProvider';

export default function SaveAsMenu() {
  const { setExtendMenu, createNewFilterSave } = useContext(filterDataContext);
  const [selectedFilter, setSelectedFilter] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const save = () => {
    const name = selectedFilter.trim();
    if (!name) return;
    createNewFilterSave(name);
    setExtendMenu(false);
    setSelectedFilter('');
  };

  return (
    <form
      className={styles.saveAsPanel}
      onSubmit={(e) => {
        e.preventDefault();
        save();
      }}
    >
      <input
        ref={inputRef}
        type="text"
        value={selectedFilter}
        placeholder="Name this filter"
        onChange={(e) => setSelectedFilter(e.target.value)}
        className={styles.saveInput}
      />
      <SlButton className={styles.saveButton} type="submit">
        Save
      </SlButton>
    </form>
  );
}
